import {
  QuoteDocumentCartOhProductType,
  QuoteDocumentCartProductQuantity,
} from "hassibot/services_v2/document/types";
import { ProclientVebEvaluationNeedType } from "hassibot/services_v2/veb-evaluation/types";
import { ValueOf } from "types";

export enum Frequency {
  WEEKLY = "WEEKLY",
  DAILY = "DAILY",
}

export const frequencyToLabel: Record<Frequency, string> = {
  [Frequency.WEEKLY]: "semaine",
  [Frequency.DAILY]: "jour",
};

export const needTypeCategory = {
  STIMULATION: "stimulation",
  MEAL: "meal",
  MORNING: "morning",
} as const;

export type NeedTypeCategory = ValueOf<typeof needTypeCategory>;

export type NeedTypeAndOhProduct = {
  label: string;
  frequency: Frequency;
  needTypes: ProclientVebEvaluationNeedType[];
  ohPackages: QuoteDocumentCartOhProductType[];
  quantity: QuoteDocumentCartProductQuantity;
  isCumulative: boolean;
};

export type NeedTypeQuantityPerProduct = Record<
  QuoteDocumentCartOhProductType,
  QuoteDocumentCartProductQuantity
>;

export type SuggestionPerCategory = Record<
  NeedTypeCategory | ProclientVebEvaluationNeedType,
  { needs: ProclientVebEvaluationNeedType[]; products: Partial<NeedTypeQuantityPerProduct> }
>;
